// akhila 1/12/2022 3031450488 added SearchTable for workqueue
// akhila 1/12/2022 3031450488 added new changes in table api payload
// akhila 3/12/2022 3031450488 added download configuration
// Saikrishna 4/12/2022 3031450488 Fixed work queue account number  default population bug
// Sohel 12/05/2022 2692790263 created For Payload Changes
// akhila 12/05/2022 2692790263 implemented Workqueue execution.
// lalitha 12/07/2022 2692790263 added Created By payload
// akhila 12/08/2022 2692790263 change labels workqueue to Work Queue
// Rajesh 12/08/2022 2692790263 changed dialog box size
// akhila 12/08/2022 2692790263 adding session storage for search items
// kavya9reddy 12/09/2022 2692790263 Added createdDate in  payload
// Ashraf 12/20/2022 2692790263 fixed user role access
// Raghu 12/26/2022 2692790263 Added Dialog Component
// kavyareddy 12/27/2022 2692790263 changed print payload for createdBy and createdFor
// kavyareddy 12/28/2022 2692790263 Added createdDate in payload
// sai krisha 30/12/2022 2692790263 add code description values
// Ashraf 01/19/2022 2692790263 Added last run date column
// Akhila 02/08/2023 2692790263 added last run date in payload
// Dilip 02/13/2023 2692790263  created for, created by payload changes
// sai krisha 02/13/2022 2692790263 added lastrundate in download configuration
// Ravi 02/22/2023 2692790263 Added Client Code column in table
// Ravi 02/24/2023 2692790263 implemented previewFile in download Configuration
// Dilip 02/27/2023 2692790263 Fixed Sorting issue
// Akhila 03/03/2023 2692790263 bug fixed prepoulation issue record in work queue fiel step
// Suresh Peddavoora 03/16/2023 2692790263 Added Dropdown in Actions Column in Table
// suresh peddavoora 04/03/2023 2692790263 add icon added
// Akhila 05/10/2023 2692790263 modified download for excel file in execution
// Sohel 05/12/2023 2692790263 Fixed Reset Select Fields issue
// Ravi 05/31/2023 2692790263 changed delete popup message
// Ravi  06/01/2023 2692790263  Added WorkQueue User and Role field
// Sohel 06/01/2023 2692790263 Added module Name in payload
// Sohel 06/01/2023 2692790263 disable Executions and run in draft mode
// Akhila 06/07/2023 2692790263 Added code and description
// Akhila 06/08/2023 2692790263 created date change to date created field and column
// Sohel 06/16/2023 2692790263 Added WorkQUeue in Add Task
// Ravi 07/22/2023 2692790263 increased copy popup size
import React, {useContext, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {tableIcons} from './../../../components/TableIcons/index';
import {httpPaginationDelete, httpPaginationPost} from './../../../util/Rest';
import {makeStyles} from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddOutlined';
import {ErrorSnackbar, SuccessSnackbar} from './../../../components/CustomSnackBar/index';
import {
  getDropDownData,
  getClientCodeData,
  getAccessMethodRunList,
  postFieldCode,
  postPrintWorkqueueMaster,
  ResetMessage as resetMsg,
  getCollectorsData,
  resetConfigUrl,
  resetDockey,
  ResetExecelSucessMsg as resetExecelSucessMsg,
  ResetUrl as resetUrl,
} from '../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchBasicInfo,
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  fetchFilter,
  resetCopyWorkQueue,
  resetMessage,
  resetReportFieldsData,
  setReduxState,
} from '../../../redux/reducers/ReportMaster/index';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import {ThemeContext} from './../../../themes/ThemeProvider';
import DeleteTableRecordPopup from './../../../util/DeleteTableRecordPopup';
import GuiTable from './../../../components/FormComponents/GuiTable';
import {resetReportMaster} from '../../../redux/reducers/ReportMaster/index';
import DialogBox from './../../../components/DialogBox/index';
import {tablePageRows} from '../../../constants/ReusableConstants';
import ReportNote from './../../FrameWorks/ReportMaster/SearchReportMaster/ReportNote';
import CopyReport from './CopyReport';
import PageLoader from './../../../components/PageLoader/index';
import ReportsExecutionTable from './../../FrameWorks/ReportMaster/SearchReportMaster/ReportsExecutionTable';
import moment from 'moment';
import {WORK_QUEUE_SETUP} from '../../../constants/ReusableRoleAccess';
import {useUpdateEffect} from 'react-use';
import axios from 'axios';
import PreviewFileDialog from '../../../util/PreviewFileDialog';
import {downloadButton} from '../../../util/Content';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
const useStyles = makeStyles((theme) => ({
  link: {
    // Changed color for Group Code Column (2700780638)
    color: '#320469 !important',
  },
}));
export default function WorkQueueSearchTable({
  setSelectedRows,
  selectedRows,
  setTabValue,
  setOpen,
  setReportDialogData,
  // setReportCode,
  setSubmit,
  submit,
  searchData,
  setSearchData,
  setCopy,
  copy,
  reportMasterSearch,
  setReportSearchCode,
  setReportSearch,
  setReportData,
  workQueue,
  setEditExisting,
}) {
  const rowDataRef = useRef();
  const queryRef = useRef(null);
  const onEditCall = (rowData) => {
    dispatch(setReduxState({property: 'fixedlength', value: rowData?.fixedLength}));
    dispatch(setReduxState({property: 'isDraftReport', value: rowData?.isDraft}));
    dispatch(setReduxState({property: 'lastStep', value: rowData?.lastStep}));
    if (!reportMasterSearch) {
      // dispatch(fetchReportMaster(rowData?.reportCode));
      // dispatch(fetchBasicInfo(rowData?.reportCode));
      setTabValue(1);
      dispatch(setReduxState({property: 'reportCode', value: rowData?.reportId}));
      dispatch(setReduxState({property: 'reportName', value: rowData?.reportCode}));
      // setReportCode(rowData?.reportCode);
      // rowData?.accessMethod &&
      //   rowData?.action &&
      //   dispatch(
      //     postFieldCode({
      //       fieldCode: rowData?.accessMethod,
      //       options: rowData?.action,
      //     })
      //   );
    }
    if (reportMasterSearch) {
      dispatch(getAccessMethodRunList());
      // dispatch(fetchReportMaster(rowData?.reportCode));
      dispatch(fetchFilter(rowData?.reportId));
      setReportData(rowData);
      setReportSearchCode(rowData);
      setReportSearch(false);
      rowData?.accessMethod &&
        rowData?.action &&
        dispatch(
          postFieldCode({
            fieldCode: rowData?.accessMethod,
            options: rowData?.action,
          }),
        );
    }
  };
  const columns = [
    {
      title: 'Work Queue Name',
      field: 'reportCode',
      render: (rowData) => (
        <span
          role="button"
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            borderBottom: '1px solid #000099',
          }}
          className={classes1.link}
          // style={{ backgroundColor: "transparent" }}
          onClick={() => {
            onEditCall(rowData);
            if (!reportMasterSearch) {
              setEditExisting(rowData?.reportCode);
            }
          }}
        >
          {rowData?.reportCode}
        </span>
      ),
    },
    {
      title: 'Work Queue Description',
      field: 'reportDescription',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.reportDescription} interactive>
            <span className="text-wraper">{rowData?.reportDescription}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Work Queue Roles',
      field: 'accessRoles',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.accessRoles?.split(',').join(', ')}>
            <span className="text-wraper">{rowData?.accessRoles?.split(',').join(', ')}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Work Queue Users',
      field: 'accessUsers',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.accessUsers?.split(',').join(', ')}>
            <span className="text-wraper">{rowData?.accessUsers?.split(',').join(', ')}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
    {
      title: 'Last Run Date',
      field: 'lastRunDate',
      render: (rowData) => {
        return rowData?.lastRunDate ? moment(rowData?.lastRunDate).format('MM/DD/YYYY') : '';
      },
    },
  ];
  const {reusableInputStyles} = useContext(ThemeContext);
  const tableRef = useRef();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [countTotal, setCountTotal] = useState('');
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [status, setStatus] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const {
    isLoading,
    successMsg,
    viewFormFileUrl,
    errorMsg,
    runReportToggle,
    configurationUrl,
    dockey,
    downloadMsgExcel,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {copySuccessMsg, copyErrorMsg, copyWorkQueueStatus, copyCode} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const [copyReport, setCopyReport] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [deleteSuccessMsg, setDeleteSuccessMsg] = useState('');
  const disabledByRole = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const [oldReportCode, setOldReportCode] = useState('');
  const [codeAndDescription, setCodeAndDescription] = useState({});
  const [reportCodeData, setReportCodeData] = useState();
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [reportExecution, setReportExecution] = useState(false);
  const classes1 = useStyles();
  useEffect(() => {
    if (successMsg || errorMsg || downloadMsgExcel) {
      setTimeout(() => {
        dispatch(resetMsg());
        dispatch(resetExecelSucessMsg());
      }, 3000);
    }
  }, [successMsg, errorMsg, downloadMsgExcel]);

  useEffect(() => {
    dispatch(resetMessage('search'));
  }, []);

  useEffect(() => {
    if (deleteErrorMsg || deleteSuccessMsg) {
      setTimeout(() => {
        setDeleteErrorMsg('');
        setDeleteSuccessMsg('');
      }, 3000);
    }
  }, [deleteErrorMsg, deleteSuccessMsg]);
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
    dispatch(getCollectorsData());
    !reportMasterSearch && setCopy(null);
  }, [dispatch]);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (copyWorkQueueStatus === 200) {
      setTimeout(() => {
        dispatch(fetchBasicInfo(copyCode));
        dispatch(resetCopyWorkQueue());
        setTabValue(1);
        setCopyReport(false);
      }, 2500);
    }
  }, [copyWorkQueueStatus]);

  useEffect(() => {
    if (copyErrorMsg || copySuccessMsg) {
      setTimeout(() => {
        dispatch(resetCopyWorkQueue());
      }, 2500);
    }
  }, [copyErrorMsg, copySuccessMsg]);

  useEffect(() => {
    if (viewFormFileUrl && viewFormFileUrl.includes('https')) {
      window.open(`${viewFormFileUrl}`, '_parent');
      dispatch(resetUrl());
    }
  }, [viewFormFileUrl]);
  useEffect(() => {
    if ((tableRef.current && submit) || runReportToggle) {
      if (runReportToggle) {
        tableRef.current.onQueryChange();
      }
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, successMsg, searchData]);

  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('report'));
      dispatch(fetchCreatedForDropDownData('report'));
      setStatus(false);
    }
  }, [status]);

  const handleDelete = (rowData) => {
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleEdit = (rowData) => {
    onEditCall(rowData);
    setEditExisting(rowData?.reportCode);
  };
  const handleNotes = (rowData) => {
    setReportCodeData(rowData);
    handleNote();
  };
  const handleCopy = (rowData) => {
    setCopy(rowData.reportId);
    setCopyReport(true);
    setOldReportCode(rowData?.reportCode);
    setCodeAndDescription(rowData);
  };
  const handleExecution = (rowData) => {
    setReportExecution(true);
    rowDataRef.current = rowData;
  };
  const handleRun = (rowData) => {
    setOpen(true);
    rowData?.accessMethod &&
      rowData?.action &&
      dispatch(
        postFieldCode({
          fieldCode: rowData?.accessMethod,
          options: rowData?.action,
        }),
      );
    setReportDialogData(rowData);
    dispatch(getAccessMethodRunList());
  };
  const handleNote = () => {
    setIsNote(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
    setIsNote(false);
  };

  const handleCopyReport = () => {
    setCopyReport(false);
  };
  const handleSubmit = () => {
    setIsLoadingDelete(true);
    new Promise((resolve) => {
      httpPaginationDelete(`reportstransaction/delete/txnreport/${userData.reportId}`)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status !== 400) {
            setDeleteSuccessMsg(response?.response);
            setSubmit(true);
            tableRef.current.onQueryChange();
            setStatus(true);
            handleCloseDialog();
            setIsLoadingDelete(false);
            resolve();
          }
          if (response?.data?.status === 400) {
            setDeleteErrorMsg(response.data.message);
            resolve();
            handleCloseDialog();
            setIsLoadingDelete(false);
          }
          resolve();
        })
        .catch((error) => {
          setIsLoadingDelete(false);
          console.log(error);
        });
    });
  };
  useEffect(() => {
    dispatch(resetReportMaster());
  }, []);
  const handleReportHistory = () => {
    setReportExecution(false);
  };

  const SearchSessionWorkQueue = JSON.parse(sessionStorage.getItem('WorkQueue'));
  if (SearchSessionWorkQueue && !submit) {
    searchData = SearchSessionWorkQueue;
  }
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
  };

  useEffect(() => {
    dispatch(setReduxState({property: 'isWorkqueueAddClicked', value: false}));
    dispatch(resetReportFieldsData());
  }, []);
  return (
    <>
      <DialogBox
        open={reportExecution}
        dialogClose={handleReportHistory}
        title="Work Queue Execution History"
        maxWidth="xl"
        hideFooter={true}
      >
        <ReportsExecutionTable executionRowData={rowDataRef?.current} workQueue={workQueue} />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Work Queue Setup'}
      />
      <DialogBox
        open={copyReport}
        dialogClose={handleCopyReport}
        title="Copy Work Queue"
        maxWidth="xl"
        hideFooter={true}
      >
        <CopyReport
          oldReportCode={oldReportCode}
          oldReportId={copy}
          codeAndDescription={codeAndDescription}
        />
      </DialogBox>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Work Queue"
        value={`Are you sure you want to delete the ${userData?.reportCode} Work Queue?`}
        handleSubmit={handleSubmit}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleCloseDialog}
        title="Work Queue Notes"
        maxWidth="xl"
      >
        <ReportNote reportCodeData={reportCodeData} workQueue={workQueue} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table new-standard-textfields custom-toolbar-icons custom-actions-icon global-field-table actions-dropdown-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `reportstransaction/search/all`;
                const bodyObj = {
                  reportCode: searchData?.code ? searchData.code : '',
                  reportDescription: searchData?.description ? searchData.description : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  isDraft: reportMasterSearch ?
                    'N' :
                    searchData?.isDraft?.key ?
                      searchData?.isDraft?.key :
                      '',
                  title: searchData?.title ? searchData?.title : '',
                  reportType: 'WQ',
                  lastRunDate: searchData?.lastRunDate ?
                    moment(searchData?.lastRunDate).format('MM/DD/YYYY') :
                    '',
                  clientCode: searchData?.clientCode?.clientNumber ?
                    searchData?.clientCode?.clientNumber :
                    '',
                  accessRoles: searchData?.role?.roleName ? searchData?.role?.roleName : '',
                  accessUsers: searchData?.user?.userName ? searchData?.user?.userName : '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        // setReportCode(null);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              header: {
                actions: reportMasterSearch ? '' : 'Actions',
              },
            }}
            // actions={
            //   !reportMasterSearch && [
            //     {
            //       icon: () => (
            //         <>
            //           <Button
            //             type="button"
            //             variant="outlisetOpenned"
            //             className={`mx-1 search-btn`}
            //             disabled={!disabledByRole?.add}
            //           >
            //             Add Work Queue
            //           </Button>
            //         </>
            //       ),
            //       disabled: !disabledByRole?.add,
            //       isFreeAction: true,
            //       hidden: reportMasterSearch,
            //       onClick: (event) => {
            //         dispatch(setReduxState({ property: "isWorkqueueAddClicked", value: true }));
            //         dispatch(setReduxState({ property: "isDraftReport", value: "Y" }));
            //         setTabValue(1);
            //       },
            //     },
            //     (rowData) => ({
            //       icon: () => <EditOutlinedIcon />,
            //       tooltip: "Edit",
            //       hidden: rowData?.repositoryType === "SYSTEM",
            //       disabled: !disabledByRole?.edit,
            //       onClick: (event, rowData) => {
            //         onEditCall(rowData);
            //         setEditExisting(rowData?.reportCode);
            //       },
            //     }),
            //     (rowData) => ({
            //       icon: () => <PlayCircleOutlineOutlinedIcon />,
            //       tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
            //       disabled: rowData?.isDraft === "Y" || !disabledByRole?.edit,
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => {
            //         setOpen(true);
            //         rowData?.accessMethod &&
            //           rowData?.action &&
            //           dispatch(
            //             postFieldCode({
            //               fieldCode: rowData?.accessMethod,
            //               options: rowData?.action,
            //             })
            //           );
            //         setReportDialogData(rowData);
            //         dispatch(getAccessMethodRunList());
            //         // dispatch(getRunReportData(rowData.reportId));
            //       },
            //     }),
            //     {
            //       icon: () => <HistoryIcon />,
            //       // hidden: nightJobSearchTrigger,
            //       tooltip: "Work Queue executions",
            //       onClick: (event, rowData) => {
            //         setReportExecution(true);
            //         rowDataRef.current = rowData;
            //       },
            //     },
            //     (rowData) => ({
            //       icon: () => <FileCopyOutlinedIcon />,
            //       tooltip: "Copy",
            //       hidden: reportMasterSearch,
            //       disabled: !disabledByRole?.add,
            //       onClick: (event, rowData) => {
            //         // dispatch(fetchReportMaster(rowData.reportCode));
            //         // setTabValue(1);
            //         setCopy(rowData.reportId);
            //         setCopyReport(true);
            //         setOldReportCode(rowData?.reportCode);
            //         setCodeAndDescription(rowData);
            //       },
            //     }),
            //     {
            //       icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Delete",
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => handleDelete(rowData),
            //       disabled: !disabledByRole?.delete,
            //     },
            //     {
            //       icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Work Queue Notes",
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => {
            //         setReportCodeData(rowData?.reportCode);
            //         handleNote();
            //       },
            //     },
            //   ]
            // }
            actions={
              !reportMasterSearch && [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  {reportMasterSearch ? (
                    <div className="mt-2"></div>
                  ) : (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn ml-2 ${classes.buttonRoot}`}
                        disabled={Boolean(countTotal === 0)}
                        onClick={() => {
                          dispatch(
                            postPrintWorkqueueMaster({
                              description: searchData?.description ? searchData.description : '',
                              code: searchData?.code ? searchData.code : '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              orderDirection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                              reportTitle: searchData?.title ? searchData?.title : '',
                              createdBy: searchData?.createdBy?.userLoginName ?
                                searchData?.createdBy?.userLoginName :
                                '',
                              createdFor: searchData?.createdFor?.userLoginName ?
                                searchData?.createdFor?.userLoginName :
                                '',
                              isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                              createdDate: searchData?.createdDate ?
                                moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                '',
                              lastRunDate: searchData?.lastRunDate ?
                                moment(searchData?.lastRunDate).format('MM/DD/YYYY') :
                                '',
                              clientCode: searchData?.clientCode?.clientNumber ?
                                searchData?.clientCode?.clientNumber :
                                '',
                            }),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  )}
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleRun={handleRun}
                  handleNotes={handleNotes}
                  handleCopy={handleCopy}
                  handleExecution={handleExecution}
                  hiddenMenu={{
                    edit: props?.data?.repositoryType === 'SYSTEM',
                    run: reportMasterSearch,
                    copy: reportMasterSearch,
                    hiddenDelete: reportMasterSearch,
                    notes: reportMasterSearch,
                    execution: false,
                    usage: true,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !disabledByRole?.edit,
                    disableRun: props?.data?.isDraft === 'Y' || !disabledByRole?.edit,
                    disableCopy: !disabledByRole?.add,
                    disableDelete: !disabledByRole?.delete,
                    disableExecution: props?.data?.isDraft === 'Y',
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        disabled={!disabledByRole?.add}
                        hidden={reportMasterSearch}
                        isFreeAction={true}
                        onClick={(event) => {
                          dispatch(
                            setReduxState({property: 'isWorkqueueAddClicked', value: true}),
                          );
                          dispatch(setReduxState({property: 'isDraftReport', value: 'Y'}));
                          setTabValue(1);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Work Queue
                      </Button>
                    }
                  </div>
                </div>
              ),
            }}
          />
        </div>
        {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
        {deleteSuccessMsg && (
          <SuccessSnackbar successMsg={'Work Queue Name Deleted Successfully '} />
        )}
      </Grid>
      {isLoadingDelete && <PageLoader />}
      {(errorMsg || copyErrorMsg) && <ErrorSnackbar errorMsg={errorMsg || copyErrorMsg} />}
      {(successMsg || copySuccessMsg || downloadMsgExcel) && (
        <SuccessSnackbar successMsg={successMsg || copySuccessMsg || downloadMsgExcel} />
      )}
    </>
  );
}
